import { render, staticRenderFns } from "./LanguagesForm.vue?vue&type=template&id=1fb7d202&"
import script from "./LanguagesForm.vue?vue&type=script&lang=js&"
export * from "./LanguagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports